var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { cn } from '../lib/utils';
var Icon = function (_a) {
    var name = _a.name, className = _a.className, alt = _a.alt, color = _a.color;
    var _b = useState(null), svgContent = _b[0], setSvgContent = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        var loadIcon = function () { return __awaiter(void 0, void 0, void 0, function () {
            var iconPath, response, svgText, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        setLoading(true);
                        setError(null);
                        iconPath = "/src/assets/icon/".concat(name, ".svg");
                        return [4 /*yield*/, fetch(iconPath)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("Failed to load icon: ".concat(response.status));
                        }
                        return [4 /*yield*/, response.text()];
                    case 2:
                        svgText = _a.sent();
                        // Replace hardcoded colors with currentColor to make it styleable
                        // But preserve fill="none" and stroke="none"
                        // Also remove hardcoded width and height to make it responsive
                        svgText = svgText
                            .replace(/fill="(?!none")[^"]*"/g, 'fill="currentColor"')
                            .replace(/stroke="(?!none")[^"]*"/g, 'stroke="currentColor"')
                            .replace(/fill='(?!none')[^']*'/g, "fill='currentColor'")
                            .replace(/stroke='(?!none')[^']*'/g, "stroke='currentColor'")
                            .replace(/width="[^"]*"/g, '')
                            .replace(/height="[^"]*"/g, '')
                            .replace(/width='[^']*'/g, '')
                            .replace(/height='[^']*'/g, '');
                        setSvgContent(svgText);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        console.error("Icon \"".concat(name, "\" not found in assets/icon directory"), err_1);
                        setError("Icon \"".concat(name, "\" not found"));
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        loadIcon();
    }, [name]);
    if (loading) {
        return (_jsx("div", { className: cn("inline-flex items-center justify-center w-6 h-6 bg-gray-200 dark:bg-muted animate-pulse rounded", className), "aria-label": "Loading icon" }));
    }
    if (error || !svgContent) {
        return (_jsx("div", { className: cn("inline-flex items-center justify-center w-6 h-6 bg-red-100 text-red-600 text-xs font-medium rounded border border-red-200", className), title: error || "Icon \"".concat(name, "\" not found"), "aria-label": error || "Icon \"".concat(name, "\" not found"), children: "!" }));
    }
    return (_jsx("span", { className: cn("inline-flex items-center justify-center [&>svg]:w-full [&>svg]:h-full", className), style: { color: color }, role: "img", "aria-label": alt || name, dangerouslySetInnerHTML: { __html: svgContent } }));
};
export { Icon };
export * from './icons';
